import { render, staticRenderFns } from "./Approver.vue?vue&type=template&id=744b1ada&scoped=true"
import script from "./Approver.vue?vue&type=script&lang=ts"
export * from "./Approver.vue?vue&type=script&lang=ts"
import style0 from "./Approver.vue?vue&type=style&index=0&id=744b1ada&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b1ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744b1ada')) {
      api.createRecord('744b1ada', component.options)
    } else {
      api.reload('744b1ada', component.options)
    }
    module.hot.accept("./Approver.vue?vue&type=template&id=744b1ada&scoped=true", function () {
      api.rerender('744b1ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/WorkApplication/Approver.vue"
export default component.exports